import { render, staticRenderFns } from "./SactionReference.vue?vue&type=template&id=f725f54e&"
import script from "./SactionReference.vue?vue&type=script&lang=js&"
export * from "./SactionReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports